import { observer } from 'mobx-react'
import React, { forwardRef, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Block, Heading } from 'suomifi-ui-components'
import LocalizedString, {
  LocalizedParagraphs,
} from 'todistukset-ui/src/vtj/components/localized-string/LocalizedString.react'

import { FormContainer } from 'todistukset-ui/src/vtj/components/order-wizard/CommonFormComponents.sc'
import { WizardPriceListContainer } from 'todistukset-ui/src/vtj/components/order-wizard/InstructionsStep/InstructionsStep.sc'
import type { StepComponent } from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import PriceListTable, {
  PriceListTableRow,
} from 'todistukset-ui/src/vtj/components/price-list/PriceListTable.react'
import { useStore } from 'todistukset-ui/src/vtj/stores/store.util'

const AetInstructionsStep: StepComponent = observer(
  forwardRef(function AetInstructionsStep({ titleId }, _ref) {
    return (
      <FormContainer>
        <Block variant="section">
          <Heading variant="h2" id={titleId}>
            <LocalizedString stringKey="aetOrdererInstructionsMainTitle" />
          </Heading>
          <LocalizedParagraphs stringKey="aetOrdererInstructionsMainDescription_paragraphs" />
        </Block>
        <Block variant="section">
          <Heading variant="h3">
            <LocalizedString stringKey="aetOrdererInstructionsDeliveryTitle" />
          </Heading>
          <LocalizedParagraphs stringKey="aetOrdererInstructionsDeliveryDescription_paragraphs" />
        </Block>
        <Block variant="section">
          <Heading variant="h3">
            <LocalizedString stringKey="aetOrdererInstructionsPriceListTitle" />
          </Heading>
          <PriceList />
        </Block>
      </FormContainer>
    )
  })
)

export default AetInstructionsStep

const PriceList: React.FC = observer(() => {
  const {
    common: { lang },
  } = useStore()
  const { t } = useTranslation()
  const priceListTables: [PriceListTableRow, ...PriceListTableRow[]][] =
    useMemo(() => {
      const electronicPrices: [PriceListTableRow, ...PriceListTableRow[]] = [
        [
          {
            text: t('orderWizardPriceListElectronicCertificate'),
            tooltip: <></>, // TODO pending tooltip content
          },
          { text: t('priceListPrice') },
        ],
        [{ text: t('aettodistus') }, { text: t('priceListNoFee') }],
      ]

      return [electronicPrices]
    }, [lang]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <WizardPriceListContainer>
      <PriceListTable tables={priceListTables} />
    </WizardPriceListContainer>
  )
})
